const selectors = {
    "login": {
        "modal" : "login-modal",
        "input" : {
            "email" : "login-input-email",
            "password" : "login-input-password",
            "code" : "login-input-code"
        },
        "button" :  "login-button",
        "alert" : "login-alert"
    },
    "connectionError" : {
        "modal" : "connectionError-modal",
    }
}


export default selectors
